module.exports = __webpack_public_path__ + "static/media/yushan_plant.02806f75.webp";